<div class="custom-modal modal-extrato-importacao">
    <div class="header">
      <h1 mat-dialog-title>
        Extrato de Importação
      </h1>
      <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div *ngIf="isLoading" class="d-flex justify-content-center">
        <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <div [hidden]="isLoading || extracts?.data?.length === 0">
      <div mat-dialog-content class="d-flex content">
        <div class="d-flex flex-column" style="flex: 1">
          <span>Cliente: {{ importDetails?.cliente }}</span>
          <span>Produto: {{ importDetails?.produto }}</span>
          <span>Processo: PROCESSO</span>
        </div>
        <div class="d-flex flex-column" style="flex: 1">
          <span>Data: {{ importDetails?.data | date: 'dd/MM/yyyy' }}</span>
          <span>Arquivo: {{ importDetails?.arquivo }}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="no-padding">
        <div>
          <table mat-table [dataSource]="extracts">
            <ng-container matColumnDef="modelo">
              <th mat-header-cell *matHeaderCellDef> Modelo </th>
              <td mat-cell *matCellDef="let extracts"> {{ extracts?.modelo }} </td>
              <td mat-footer-cell *matFooterCellDef><Strong>Total</Strong></td>
            </ng-container>

            <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef> Nº Sequêncial </th>
              <td mat-cell *matCellDef="let extracts"> {{ extracts?.codigo }} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="codigoBarra">
              <th mat-header-cell *matHeaderCellDef> Código de Barras </th>
              <td mat-cell *matCellDef="let extracts"> {{ extracts?.codigoBarra }} </td>            <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="filial">
              <th mat-header-cell *matHeaderCellDef> Filial </th>
              <td mat-cell *matCellDef="let extracts"> {{ extracts?.filial }} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="statusImportacao">
              <th mat-header-cell *matHeaderCellDef> Status Lógico </th>
              <td mat-cell *matCellDef="let extracts"> {{ extracts?.statusImportacao }} </td>
              <td mat-footer-cell *matFooterCellDef><strong>{{ totalContagemExtrato() }} </strong></td>
            </ng-container>

            <ng-container matColumnDef="recepcaoFisica">
              <th mat-header-cell *matHeaderCellDef> Recepção Física </th>
              <td mat-cell *matCellDef="let extracts"> {{ extracts?.recepcaoFisica | date: 'dd/MM/yyyy' }} </td>
              <td mat-footer-cell *matFooterCellDef><strong> {{ totalRecepcionado() }} </strong></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
          </table>
          </div>
          <app-paginacao [pageIndex]="paging?.index"
            [pageSize]="paging?.size"
            [length]="paging?.length"
            (page)="onPageChange($event)"
            [pageSizeOptions]="[5]"></app-paginacao>
      </div>
    </div>
    <div *ngIf="!isLoading && extracts?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px;">
      Nenhum registro para o período!
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
      <button mat-flat-button mat-dialog-close color="primary">OK</button>
    </div>
  </div>